import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      segmentationTime: [],
      draw: false,
      offX: 0,
      offY: 0,
      throttleTime: null,
      prevLoad: false, // 上拉加载状态
      loadTime: null,
      chatUserDetail: false, // 对话框用户信息
      prevChatList: null,
    }
  },
  computed: {
    ...mapState('im', ['currentSession', 'msgMap', 'unsendMsgs']),
    ...mapState("dataCenter", ["notification"]),
    ...mapState("im", ["UIControl", "sessions", "messages", "loadingMessage", "unsendMsgs", "dragChatbox"]),
    ...mapGetters('im', ['singleMap', 'teamsMap']),
    chatList() {
      const messageChatItem = this.msgMap[this.currentSession] || [];
      const unsendMsgChatItem = this.unsendMsgs[this.currentSession] || [];
      return messageChatItem.concat(unsendMsgChatItem).sort((x, y) => {
        return new Date(x.time).getTime() - new Date(y.time).getTime()
      });
    },
    hideChatInput() {
      if (this.singleMap[this.currentSession] ) {
        return this.singleMap[this.currentSession].isDelete ? true : false
      } else if (this.teamsMap[this.currentSession]) {
        return this.teamsMap[this.currentSession].isDelete ? true : false
      } else return true
    }
  },
  methods: {
    ...mapActions("im", ["previousPage", "srollBottom", "prevHistory"]),
    /**
     * 获取历史消息
     */
    getHistoryChat() {
      this.previousPage(this.currentSession);
    },
    scrollTopChat(e) {
      if (e.target.scrollTop <= 0) {
        this.loadTime = Date.now();
        setTimeout(() => {
          this.srollBottom(false);
        }, 50);
        this.getHistoryChat();
      }
    },
  },
}